import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {Range} from "../utils/Range";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {TraderOfferGroup} from "@/modules/redactor/models/trader/TraderOfferGroup";


export class TraderOfferRule extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(TraderOfferRule, v) : SKIP;
        }, (v) => {
            return deserialize(TraderOfferRule, v);
        });
    }

    constructor() {
        super();

        this._group = null;
        this._amount = new Range(0, 0);
        this._currency = null;
        this._mandatory = false;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get mandatory() {
        return this._mandatory;
    }

    set mandatory(value) {
        this._mandatory = value;
    }

    valid() {

        if (!this.group || !TraderOfferGroup.is(this.group)) {
            return false;
        }

        if (!this.amount || !this.amount.valid() || this.amount.empty()) {
            return false;
        }

        if (this.currency && !CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (this.mandatory && this.amount.lower <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.amount || this.amount.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TraderOfferRule());
        } else if (target instanceof TraderOfferRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TraderOfferRule, {
    _group: alias("group", TraderOfferGroup.schema()),
    _amount: alias("amount", Range.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _mandatory: alias("mandatory", Schema.primitive())
});